import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};

const SvgWarningIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      style={{ WebkitTransform: `scale(${size / 40})` }}
      {...props}
    >
      <g clipPath="url(#warning-icon_svg__a)">
        <path
          d="M35.817 29.184 23.513 4.404A.72.72 0 0 0 22.866 4h-5.845a.733.733 0 0 0-.647.404L4.071 29.184a.736.736 0 0 0-.035.543l1.64 5.788c.105.289.37.485.67.485H33.53c.3 0 .578-.196.67-.485l1.64-5.788a.74.74 0 0 0-.034-.543h.012ZM18.36 16.154c0-.267.208-.475.474-.475h2.206c.266 0 .474.208.474.474v6.597a.468.468 0 0 1-.474.473h-2.206a.468.468 0 0 1-.474-.473v-6.597Zm3.165 11.933a.469.469 0 0 1-.473.473h-2.218a.469.469 0 0 1-.474-.473v-2.218c0-.266.208-.474.474-.474h2.218c.265 0 .473.208.473.474v2.218Z"
          fill={color || "#F7F6F5"}
        />
      </g>
      <defs>
        <clipPath id="warning-icon_svg__a">
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgWarningIcon;
